import axios from 'axios'
import {API_TeletHealth, API_Utility, GetAPIBaseURL} from "./API";
import {Logger} from "./Log";
import {AESKey, AESTool, MD5Tool} from "./cryptTool";
import {getRole} from "./global";
import {MeetingRole} from "./customEnum";
import {GrayLog} from "../grayLog/grayLog";

let APIMap = new Map();
let APIAppLogStatusMap = new Map();

const BlackListAPI = {
	getCurrent() {
		return new Set([API_Utility.appLogs])
	},
	includes(api) {
		return this.getCurrent().has(api)
	}
};

const HttpTool = {

	onRequestBegin(apiHash, api, param) {
		// !BlackListAPI.includes(api) && this.addAPIAppLogEvent(apiHash, api, param);

		APIMap.set(apiHash, {beginDate: (new Date())});
	},

	onRequestFinished(apiHash, api, param, statusCode, responseJson, errorJson) {
		// !BlackListAPI.includes(api) && this.updateAPIAppLogEvent(apiHash, statusCode, responseJson, errorJson);

		let obj = APIMap.get(apiHash);
		let additionalInfo;
		if (obj && obj.beginDate) {
			let endDate = new Date();
			additionalInfo = {duration: (endDate.getTime() - obj.beginDate.getTime())};
		}

		APIMap.delete(apiHash);

		GrayLog.network(
			api,
			statusCode,
			Object.assign({
				param: (statusCode !== 200 && param) ? AESTool.encrypt(param, AESKey.log) : '',
				errMsg: errorJson || ''
			}, additionalInfo || {})
		);
	},

	post(api, param, success, fail) {
		const baseURL = (window.location.href.indexOf('localhost') !== -1) ? 'ezhealth/' : GetAPIBaseURL()
		axios.defaults.baseURL = baseURL
		axios.defaults.headers.post['Content-Type'] = 'application/json';
		axios.defaults.withCredentials = true
		axios.defaults.timeout = 40000 //3000 ms

		Logger.print(api, '==> param =>', param);

		let reqParam = Object.assign({}, param)
		if (api === API_TeletHealth.saveAttachment) {
			reqParam.content = "" //不用上传img_base64_data
		} else if (api === API_TeletHealth.addChatScreenShot) {
			reqParam.photo = ''  //不用上传img_base64_data
		}
		let reqParam_str = JSON.stringify(reqParam);
		let apiSerialId = this.getAPISerialID(api, reqParam_str);

		if (!BlackListAPI.includes(api)) {
			axios.defaults.headers.common['APISerialID'] = apiSerialId;
		}

		this.onRequestBegin(apiSerialId, api, reqParam_str);

		axios.post(api, param)
		.then(response => {
			Logger.print(api, '==> response =>', response);
			success && success(response.data);

			let statusCode = response.status;
			let data_str = JSON.stringify(response.data);
			this.onRequestFinished(apiSerialId, api, reqParam_str, statusCode, statusCode === 200 ? data_str : '', statusCode === 200 ? '' : data_str);
		})
		.catch(error => {
			Logger.print(api, '==> error =>', error);
			let cusError = this.processError(error);
			fail && fail(cusError || error)
			this.onRequestFinished(apiSerialId, api, reqParam_str, cusError?.code || 0, '', cusError?.error ? JSON.stringify(cusError?.error) : error?.message);
		});
	},

	processError(error) {
		if (!error) {return;}
		if (!error.response) {return;}

		let {config, status, statusText, data} = error.response;

		let mError = {
			message: statusText,
			stack: data
		};
		return  {
			code: status,
			api: config.url,
			param: config.data,
			error: mError
		};
	},

	addAPIAppLogEvent(apiSerialID, apiName, params) {
		let date = new Date()

		Logger.print("current role: " + getRole())
		let userId = (getRole() === MeetingRole.doctor ? 'dr-web-telehealth' : 'pt-web-telehealth')//这里传递前缀区分病人/医生

		let event = {
			APISerialID: apiSerialID,
			UserID: userId,
			BeginDate: date.toISOString(),
			EndDate: "",
			APIName: apiName,
			Params: params ? params : '',
			StatusCode: '',
			Response: "",
			Duration: 0,
			Error: "",
		}

		APIAppLogStatusMap.set(apiSerialID, event)
	},

	updateAPIAppLogEvent(key, statusCode, response, error) {
		let event = APIAppLogStatusMap.get(key)
		if (event) {
			let endDate = new Date()
			let beginDate = new Date(event.BeginDate)
			let duration = (endDate.getTime() - beginDate.getTime())

			let data = {
				APISerialID: event.APISerialID,
				UserID: event.UserID,
				BeginDate: event.BeginDate,
				EndDate: endDate.toISOString(),
				APIName: event.APIName,
				Params: event.Params,
				StatusCode: statusCode,
				Response: response ? response : "",
				Duration: duration,
				Error: error ? error : "",
				AppVersion: '',
				SystemVersion: '',
				Platform: '',
				PhoneModel: ''
			}

			APIAppLogStatusMap.delete(key)
			this.uploadAppLog([data])
		}
	},

	getAPISerialID(apiName, params) {
		return MD5Tool.encrypt(apiName + params + (new Date()).getTime())
	},

	uploadAppLog(events) {
		let param ={
			AppLogs: events
		}

		this.post(API_Utility.appLogs, param, (response) => {
			Logger.print(JSON.stringify('app logs response: ' + JSON.stringify(response)))
		}, (error) => {
			Logger.print(JSON.stringify('app logs response: ' + error.message))
		})
	}
}

export default HttpTool


